import { defineComponent, h } from 'vue';
import { QRadio, QField, QIcon, QTooltip } from 'quasar';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';

export default defineComponent({
    name: 'form-radios-dsgn',
    components: {
        QRadio,
        QField,
        QIcon,
        QTooltip,
    },
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedNode == this;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        designmodel: null,
        schema: null,
        form: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
    },
    render() {
        const titletext = this.form?.title || this.schema.title;
        const description = this.form?.description || this.schema.description;
        const options = [];
        const schema = this.designmodel;
        const enums = schema.enum || schema.titleMap;
        if (Array.isArray(enums)) {
            for (var i = 0; i < enums.length; i++) {
                const item = enums[i];
                if (item && typeof item === 'object')
                    options.push({ label: item.name, value: item.value });
                else
                    options.push({ label: item, value: item });
            }
        }
        const modelValue = this.cmodel?.[this.schemakey];

        const title = (
            <span>
                {titletext}
                {description ? (
                    <QIcon size="xs" class="q-pl-xs form-hint-icon" name="mdi-information">
                        <QTooltip>{description}</QTooltip>
                    </QIcon>
                ) : null}
            </span>
        );

        const radios = options.map((opt) => (
            <QRadio
                key={String(opt.value)}
                val={opt.value}
                modelValue={modelValue}
                xdisable
            >
                {opt.label}
            </QRadio>
        ));

        return (
            <div
                class={{ 'designer-form': true }}
                style={{ xmarginLeft: (this.child * 15) + 'px', position: 'relative' }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <div
                    style="border-width: 1px; border-color: gray; border-style: solid; border-radius: 8px; padding: 5px 0 0 10px;"
                    class="q-mb-sm"
                >
                    {title}
                    <QField
                        modelValue={modelValue}
                        borderless
                        hide-bottom-space
                        dense
                    >
                        <div class="column">
                            {radios}
                        </div>
                    </QField>
                </div>
            </div>
        );
    }
});
